import request from '@/Utilities/httpRequest';

const participants = {
    strict: true,
    namespaced: true,
    state: {
        registrations: [],
        filters: {},
        pagination: null,
        urlAction: null,
        isLoading: false,
        order: 'CREATION_DATE',
        otiBlockName: null
    },
    mutations: {
        addRegistrations(state, participants) {
            state.registrations = state.registrations.concat(participants);
        },
        setRegistrations(state, participants) {
            state.registrations = participants;
        },
        pagination(state, value) {
            state.pagination = value;
        },
        filters(state, value) {
            state.filters = value;
        },
        urlAction(state, value) {
            state.urlAction = value;
        },
        isLoading(state, value) {
            state.isLoading = value;
        },
        orderBy(state, value) {
            state.order = value;
        },
        otiBlockName(state, value) {
            state.otiBlockName = value;
        }
    },
    actions: {
        async loadMore(context) {
            context.dispatch('isLoading', true);
            const { data } = await request.get(context.state.urlAction, {id: context.getters.contestId,page: context.getters.nextPage, orderBy: context.state.order}, false);
            context.dispatch('setData', data);
            context.dispatch('isLoading', false);
        },
        orderBy(context, value){
            context.commit('orderBy', value);
        },
        isLoading(context, value){
            context.commit('isLoading', value);
        },
        setData(context,data){
            if(!data){
                return;
            }
            if('pagination' in data){
                context.commit('pagination', data.pagination);
            }
            if('participants' in data){
                context.commit('addRegistrations', data.participants);
            }
            if('filters' in data){
                context.commit('filters', data.filters);
            }
            context.commit('otiBlockName', 'otiBlockName' in data ? data.otiBlockName : null);
        }
    },
    getters: {
        currentPage: state => state.pagination?.current ?? 0,
        nextPage: state => state.pagination?.nextPage ?? 1,
        registrations: state => state.registrations,
        pagination: state => state.pagination,
        contestId: (state, getters, rootState, rootGetters) => rootGetters.contestId,
        isLoading: state => state.isLoading,
        otiBlockName: state => state.otiBlockName
    },
};

export default participants;